export const BASEPUB_API_PING_PATH = "/api/ping";
export const BASEPUB_API_PING_URL = "/basepub" + BASEPUB_API_PING_PATH;
export const BASEPUB_API_PING_INTERVAL = 2000;
